// extracted by mini-css-extract-plugin
module.exports = {"chanceOfScoringGraph":"ChanceOfScoringGraph_chanceOfScoringGraph__gdEZN"};